import { Button, CircularProgress } from "@mui/material";
import React from "react";
import clsx from "clsx";

type CustomButtonProps = {
  name: string;
  onClick?: () => void;
  disabled?: any;
  variant?: string;
  style?: any;
  loading?: boolean;
  endIcon?: any;
  startIcon?: any;
  padding?: string | number;
  fullWidth?: any;
  width?: any;
};
const CustomButton: React.FC<CustomButtonProps> = ({
  name,
  onClick,
  disabled,
  loading,
  padding,
  variant,
  style,
  endIcon,
  startIcon,
  fullWidth,
  width,
}) => {
  return (
    <Button
      variant="contained"
      className={clsx("ROOT", {
        disable: disabled,
        primary: !disabled && variant === "primary",
        secondary: !disabled && variant === "secondary",
      })}
      onClick={onClick}
      sx={{
        ...style,
        padding: padding ?? "5px 16px 5px 16px",
        minHeight: "32px",
        width: { width },
        gap:"8px",
        whiteSpace: "nowrap",
      }}
      disabled={disabled}
      endIcon={endIcon}
      startIcon={startIcon}
      fullWidth={fullWidth}
    >
      {name}&nbsp;
      {loading && (
        <CircularProgress
          color="secondary"
          sx={{
            "&:hover": {
              color: "info.main",
              bgcolor: "#EDF1F4",
              border: `2px solid #EDF1F4`,
              boxShadow: "none",
            },
          }}
          size={12}
          thickness={5}
        />
      )}
    </Button>
  );
};

export default CustomButton;
